import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Auth } from 'src/app/models/auth';
import { BlockRequest, UpdateRequest } from 'src/app/models/physical-card';
import { FilterVehicle, Fuels, Species, Vehicle } from 'src/app/models/vehicle';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { PhysicalCardService } from 'src/app/services/physical-card.service';
import { VehicleService } from 'src/app/services/vehicles.service';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { GenericValidator } from 'src/app/shared/validators/generic-validator.validator';

@Component({
  selector: 'app-veiculos-list',
  templateUrl: './veiculos-list.component.html',
  styleUrls: ['./veiculos-list.component.css']
})
export class VeiculosListComponent implements OnInit {

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private modalService: NgbModal,
        private _formBuilder: FormBuilder,
        private alertService: NewAlertService,
        private authenticationService: AuthenticationService,
        private vehicleService: VehicleService,
        private physicalCardService: PhysicalCardService,

    ) { }

    private currentUser: Auth;

    public filters = new FilterVehicle;
    public filterOn = false;
    public vehiclesList: Vehicle[];
    public speciesList: Species[];
    public fuelsList: Fuels[];

    public vehicleSelected: Vehicle;
    temp: boolean;
    cardPassword: any;

    cardPasswordResetFormGroup: FormGroup;

    // páginação
    currentPage = 1;
    showItem = '10';
    totalItems = 0;

    ngOnInit() {
        this.currentUser = this.authenticationService.currentUserValue;

        this.loadLists();
        this.pagevehicles(1);
    }

    pagevehicles(page) {

        this.currentPage = page;
        const offset = (this.currentPage - 1) * +this.showItem;

        this.vehicleService.getAllPaged(this.currentUser.token.assignorGuid, this.currentUser.token.userReferenceId,offset,+this.showItem,this.filters)
        .subscribe(response => {
            if (response.status === ApiError.Sucesso) {
            this.vehiclesList = response.result.items;
            this.totalItems = response.result.totalItems;
            }
        });
    }

    loadLists() {
        this.vehicleService.getSpecies().subscribe(response => {
        this.speciesList = response.result.filter(x => x.isActive);
        });
        this.vehicleService.getFuels().subscribe(response => {
        this.fuelsList = response.result;
        });
    }

    showItemChanged(event) {
        this.showItem = event;
        this.pagevehicles(1);
    }

    showFilter(content: any) {
        this.modalService.open(content, { centered: true, size: 'lg' });
    }

    applyFilter() {
        this.filterOn = !(
        (this.filters.fuel == null || this.filters.fuel == 0) &&
        (this.filters.model == null || this.filters.model == '') &&
        (this.filters.nickName == null || this.filters.nickName == '') &&
        (this.filters.manufacturer == null || this.filters.manufacturer == '') &&
        (this.filters.registrationPlate == null || this.filters.registrationPlate == '')
        )
        this.pagevehicles(1);
    }

    deleteFilter() {
        this.filters = new FilterVehicle;

        this.filterOn = false;

        this.pagevehicles(1);
    }

    vehiclesEdit(id){
        this.router.navigate([`edit/${id}`], {relativeTo: this.route.parent});
    }

    vehiclesConductors(id){
        this.router.navigate([`conductors/list`], { queryParams: { id: id }, relativeTo: this.route.parent});
    }

    vehiclesPhysicalCard(id){
        this.router.navigate([`bind-card`], { queryParams: { id: id }, relativeTo: this.route.parent});
    }

    goToCreate() {
        this.router.navigate(['portal/veiculos/create']);
    }

    getFuelDescription(fuelId) {
        return this.fuelsList?.find(f => f.id === fuelId)?.description;
    }

    showModalVerCartao(content: any, item: Vehicle){
    this.vehicleSelected = item;
    this.cardPassword = null;
    this.modalService.open(content, {
        centered: true,
        size: 'lg'
    });
    }

    showModalConfimacao(content: any, item: boolean){
        this.temp = item;
        this.modalService.open(content, {
            centered: true,
            size: 'md'
        });
    }

    showModalTrocarSenhaCartao(content: any, item: Vehicle){
        this.vehicleSelected = item;

        this.cardPasswordResetFormGroup = this._formBuilder.group({
            newCardPin: new FormControl(null, [
                Validators.required,
                Validators.minLength(4),
                Validators.maxLength(4)
            ]),
            confirmNewCardPin: new FormControl(null, [
                Validators.required,
                GenericValidator.mustMatch('newCardPin')
            ])
        });


        this.modalService.open(content, {
            centered: true,
            size: 'lg'
        });
    }

    trocarSenhaCartao(){
        //requisitar pedido troca de cartão - api cartoes?
        if (!this.cardPasswordResetFormGroup.valid) return;

        let updateRequest = new UpdateRequest();
        updateRequest.psCardId = this.vehicleSelected.cardId;
        updateRequest.managerGuid = this.currentUser.token.userReferenceId;
        updateRequest.newCardPin = this.cardPasswordResetFormGroup.get('newCardPin').value;
        updateRequest.confirmNewCardPin = this.cardPasswordResetFormGroup.get('confirmNewCardPin').value;

        this.physicalCardService.changeCardPasswordLegalPerson(updateRequest).subscribe(
            result => {
                if(result.status == ApiError.Sucesso){
                    this.modalService.dismissAll();
                    this.alertService.success("Troca de senha realizada com sucesso!");
                }
                else{
                    this.modalService.dismissAll();
                    this.alertService.error(result.message);
                }
            },
            error => {console.error(error);
            }
        )
    }

    bloquearCartao(temporary: boolean = false, redirect: boolean = false){
        let index = this.vehiclesList.findIndex((obj => obj.id == this.vehicleSelected.id));

        let blockRequest = new BlockRequest();
        blockRequest.psCardId = this.vehicleSelected.cardId;
        blockRequest.managerGuid = this.currentUser.token.userReferenceId;
        if(this.cardPassword) blockRequest.password = this.cardPassword;

        if(!temporary){
            this.physicalCardService.blockDefinitiveLegalPerson(blockRequest, 35).subscribe(
                result => {
                    if(result.status == ApiError.Sucesso){
                        this.modalService.dismissAll();
                        this.alertService.success("Cartão bloqueado com sucesso!");
                        this.vehiclesList[index].definitiveBlock = true;
                    }else{
                        this.modalService.dismissAll();
                        this.alertService.error(result.message);
                    }
                }
            )
        }

        if(temporary){
            this.physicalCardService.blockTemporaryLegalPerson(blockRequest).subscribe(
                result => {
                    if(result.status == ApiError.Sucesso){
                        this.modalService.dismissAll();
                        this.alertService.success("Cartão bloqueado temporariamente com sucesso!");
                        this.vehiclesList[index].temporaryBlock = true;
                    }
                    else{
                        this.modalService.dismissAll();
                        this.alertService.error(result.message);
                    }
                }
            )
        }
    }

    desbloquearCartao(otherReason: string){
        let index = this.vehiclesList.findIndex((obj => obj.id == this.vehicleSelected.id));

        let blockRequest = new BlockRequest();
        blockRequest.psCardId = this.vehicleSelected.cardId;
        blockRequest.managerGuid = this.currentUser.token.userReferenceId;

        this.physicalCardService.unblockTemporaryLegalPerson(blockRequest).subscribe(
            result => {
                if(result.status == ApiError.Sucesso){
                    this.modalService.dismissAll();
                    this.alertService.success("Cartão desbloqueado com sucesso!");
                    this.vehiclesList[index].temporaryBlock = false;
                }
                else{
                    this.modalService.dismissAll();
                    this.alertService.error(result.message);
                }
            }
        )
    }


}
